import React from 'react'

import styled from 'styled-components';

const ProfileContainer = styled.div`
  flex: 6;
  margin-top: 70px;
`;
const Legalcalander = () => {
  return (
    <ProfileContainer>

      <div className="container text-center">
        <div className="row">
          <div className="col">
            <h1>Legal calander</h1>
            <p> Gujarat High Court</p>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <img
              src="images/Holidays.png"
              alt="Image"
              className="img-fluid"
              style={{ width: 2000, height: 550 }}
            />
          </div>
        </div>

        
      </div>

    </ProfileContainer>
  )
}

export default Legalcalander